<template>
  <div class="login-layout">
    <logo />
    <div class="content-container">
      <router-view class="app-login-content" name="content" />
    </div>
    <router-view class="app-login-footer" name="footer" />
  </div>
</template>

<script>
import Logo from '@/components/header/Logo.vue';

export default {
  components: {
    Logo,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/fonts';
@import '~@/assets/styles/colors';
@import '~@/assets/styles/metrics';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.login-layout {
  height: fit-content;
  padding: $medium;
  min-height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $background-blue;
}

.content-container {
  max-width: 480px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px;
  border-radius: $border-radius;
  background-color: $white;
  box-shadow: 0 0 8px 0 rgba(17, 25, 53, 0.16);
  color: $dark-grey;
  margin: 40px 0 25px;
}

@media (max-width: $login-base-breakpoint) {
  .login-layout {
    background: $white;
  }

  .content-container,
  .app-login-content {
    width: 100%;
    box-shadow: none;
    padding: 0;
  }
}
</style>
